import { useRef } from "react";
import Icon from "../ds/Icon";

/*
  A card's cover: image or video (plays while hovered). Without one it shows
  the Figma "Media placeholder": the card type's icon and name on a quiet fill.
*/
const CardMedia = ({ src, isVideo = false, placeholderIcon = null, placeholderLabel = "", className = "", children }) => {
  const videoRef = useRef(null);

  return (
    <div
      className={`relative w-full shrink-0 overflow-hidden bg-fill-quaternary ${className}`}
      onMouseEnter={isVideo ? () => videoRef.current?.play().catch(() => {}) : undefined}
      onMouseLeave={
        isVideo
          ? () => {
              const video = videoRef.current;
              if (video) {
                video.pause();
                video.currentTime = 0;
              }
            }
          : undefined
      }
    >
      {src ? (
        isVideo ? (
          <video ref={videoRef} src={src} className="absolute inset-0 h-full w-full object-cover" muted loop playsInline preload="metadata" />
        ) : (
          <img src={src} alt="" className="absolute inset-0 h-full w-full object-cover" />
        )
      ) : (
        placeholderIcon && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-space-8 text-label-tertiary" aria-hidden="true">
            <Icon name={placeholderIcon} size={32} />
            {placeholderLabel && <span className="text-caps-label uppercase">{placeholderLabel}</span>}
          </div>
        )
      )}
      {children}
    </div>
  );
};

export default CardMedia;
